import {FC, useState} from 'react'
import clsx from 'clsx'
import get from 'lodash/get'
import toUpper from 'lodash/toUpper'
import {KTSVG} from '_metronic/helpers'

type Props = {
  children: any
  id?: string
  sort?: boolean
  className?: string
  orderDirection?: string
  onClick?: (params: any) => void
}

const directions = {
  ASC: 'ASC',
  DESC: 'DESC',
}
const icons = {
  ASC: '/media/icons/duotune/arrows/arr073.svg',
  DESC: '/media/icons/duotune/arrows/arr072.svg',
}

const TableHeaderCell: FC<Props> = ({children, className, id, sort, onClick, orderDirection}) => {
  const [direction, setDirection] = useState(orderDirection || directions.ASC)

  const handleSort = () => {
    let dir
    if (direction === directions.ASC) {
      dir = directions.DESC
    } else {
      dir = directions.ASC
    }
    setDirection(dir)
    if (onClick) {
      onClick(`${toUpper(id)}_${dir}`)
    }
  }

  return (
    <th className={clsx(className)}>
      {children}
      {sort && (
        <KTSVG
          path={get(icons, direction)}
          className='svg-icon-3 cursor-pointer ms-1'
          onClick={handleSort}
        />
        // <button
        //   onClick={handleSort}
        //   className='btn btn-icon btn-sm h-auto btn-color-gray-400 btn-active-color-primary'
        //   title='sort'
        // >

        // </button>
      )}
    </th>
  )
}

export default TableHeaderCell
